<template>
    <aside class="col-md-4 actions">

        <!-- Login Register  -->
        <template v-if="status === 'registration_open' && ! event.register_link && ! $auth.check()">
            <div class="actions-container actions-container--login">
                  <h2>{{ 'book'|t }}</h2>
                  <p>{{ 'text-book-guest'|t }}</p>
    
                <div class="d-flex flex-md-row align-items-start aligne-items-md-center">
                    <router-link class='btn-link mr-2' to='/register' exact>
                        <span>{{'create-account'|t}}</span>
                    </router-link>
                    <router-link class='btn-link' to='/login' exact>
                        <span>{{'login'|t}}</span>
                    </router-link>
                </div>
            </div>
        </template>

        <!-- External link registration -->
        <template v-if="status === 'registration_open' && event.register_link">
            <div class="actions-container actions-container--register">
                <h2>{{ 'book'|t }}</h2>
    
                <a :href="event.register_link" class="btn">
                    <span>{{ 'book'|t }}</span>
                    <span>
                        <svg xmlns="http://www.w3.org/2000/svg" width="6" height="6" viewBox="0 0 6 6">
                        <path id="Tracé_31" data-name="Tracé 31" d="M10.985,7.7,6.689,12l-.706-.706,4.3-4.3H6.492V6h5.49v5.49h-1Z" transform="translate(-5.983 -6)" fill="#acd3ae"/>
                        </svg>
                    </span>
                </a>
            </div>
        </template>

        <!-- Get ticket -->
        <template v-if="status === 'registration_open' && event.show_register_btn && ! event.register_link && $auth.check()">
            <div class="actions-container actions-container--register">
                <h2>{{ 'book'|t }}</h2>
    
                <div class="register-box">
    
                    <div class="register-box--label">
                        <p>Tickets</p>
                        <p v-if="event.max_tickets_per_user">{{ availableTickets}} max.</p>
                    </div>
    
                    <div class="register-box--tickets">
                        <button class="button-minus" @click="removeTicket">-</button>
                        <span>{{ tickets }}</span>
                        <button class="button-plus" @click="addTicket">+</button>
                    </div>
                </div>
    
                <button class="btn" :disabled="tickets < 1" @click="addToCart">
                    <span>{{ 'add-cart'|t }}</span>
                </button>
    
                <p class="conditions first">{{ 'tickets-rule'|t }} <a href="/terms-of-use">{{ 'cgu'|t }}</a></p>
                <p class="conditions">{{ 'tickets-rule-2'|t }}</p>
            </div>
        </template>

        <!-- Login notification  -->
        <template v-if="status === 'notifications_open' && ! event.register_link && ! $auth.check()">
            <div class="actions-container actions-container--login-notifications">
                <h2>{{ 'register'|t }}</h2>
    
                <p class="date">{{ 'booking-start'|t }} {{ event.registration_open_date | formatDateEvent }}</p>
    
                <p>{{ 'text-notify-guest'|t }}</p>
    
                <div class="d-flex flex-md-row align-items-start aligne-items-md-center">
                    <router-link class='btn-link btn-link--small mr-2' to='/register' exact>
                        <span>{{'create-account'|t}}</span>
                    </router-link>
                    <router-link class='btn-link btn-link--small' to='/login' exact>
                        <span>{{'login'|t}}</span>
                    </router-link>
                </div>
            </div>
        </template>

        <!-- Get notification  -->
        <template v-if="status === 'notifications_open' && ! event.register_link && $auth.check() && ! userStatus">
            <div class="actions-container actions-container--notifications">
                <div class="text">
                    <h2>{{ 'register'|t }}</h2>
        
                    <p class="date">{{ 'booking-start'|t }} {{ event.registration_open_date | formatDateEvent }}</p>
        
                    <p>{{ 'text-notify-auth'|t }}</p>
                </div>
    
                <button class="btn" @click="toggleNotify">
                    <span>{{ 'notify-me'|t }}</span>
                </button>
            </div>
        </template>

        <!-- Notification asked  -->
        <template v-if="status === 'notifications_open' && ! event.register_link && $auth.check() && userStatus === 'notification_requested'">
            <div class="actions-container actions-container--notifications-asked">

                <div class="text">
                    <h2>{{ 'register'|t }}</h2>
        
                    <p class="date">{{ 'booking-start'|t }} {{ event.registration_open_date | formatDateEvent }}</p>
        
                    <p>
                        <span>{{ 'reminder-sub'|t }}</span>
                        <span>
                            <svg xmlns="http://www.w3.org/2000/svg" width="11.982" height="8.488" viewBox="0 0 11.982 8.488">
                            <path id="Tracé_26" data-name="Tracé 26" d="M8.129,12.469,14.62,5.979l1,1L8.129,14.466,3.636,9.973l1-1Z" transform="translate(-3.636 -5.979)" fill="#acd3ae"/>
                            </svg>
                        </span>
                    </p>
                </div>
    
                <a href="#" class="btn-link btn-link--small" @click.prevent="toggleNotify">
                    <span>{{ 'unsub'|t }}</span>
                </a>
            </div>
        </template>

        <!-- Login event full  -->
        <template v-if="status === 'event_full' && ! event.register_link && ! $auth.check()">
            <div class="actions-container actions-container--login-full">
                <h2>{{ 'sold-out'|t }}</h2>
    
                <p>{{ 'sold-out-text-guest'|t }}</p>
    
                <div class="d-flex flex-md-row align-items-start aligne-items-md-center">
                    <router-link class='btn-link btn-link--small mr-2' to='/register' exact>
                        <span>{{'create-account'|t}}</span>
                    </router-link>
                    <router-link class='btn-link btn-link--small' to='/login' exact>
                        <span>{{'login'|t}}</span>
                    </router-link>
                </div>
            </div>
        </template>

        <!-- Get on waiting list -->
        <template v-if="status === 'event_full' && ! event.register_link && $auth.check() && userStatus != 'on_waiting_list' && userStatus != 'registered_and_waiting'">
            <div class="actions-container actions-container--waiting-list">

                <div class="text">
                    <h2>{{ 'sold-out'|t }}</h2>
        
                    <p>{{ 'sold-out-text'|t }}</p>
                </div>

                <button class="btn" @click="toggleWaitingList">
                    <span>{{ 'notify-me'|t }}</span>
                </button>
            </div>
        </template>

        <!-- Is on waiting list  -->
        <template v-if="status === 'event_full' && ! event.register_link && $auth.check() && (userStatus === 'on_waiting_list' || userStatus === 'registered_and_waiting')">
            <div class="actions-container actions-container--waiting-list-asked">

                <div class="text">

                    <h2>{{ 'sold-out'|t }}</h2>
        
                    <p>
                        <span>{{ 'asked-for-place-text'|t }}</span>
                        <span>
                            <svg xmlns="http://www.w3.org/2000/svg" width="11.982" height="8.488" viewBox="0 0 11.982 8.488">
                            <path id="Tracé_26" data-name="Tracé 26" d="M8.129,12.469,14.62,5.979l1,1L8.129,14.466,3.636,9.973l1-1Z" transform="translate(-3.636 -5.979)" fill="#acd3ae"/>
                            </svg>
                        </span>
                    </p>
                </div>
    
                <a href="#" class="btn-link btn-link--small" @click.prevent="toggleWaitingList">
                    <span>{{ 'unsub'|t }}</span>
                </a>
            </div>
        </template>

        <!-- Event over  -->
        <template v-if="status === 'event_over'">
            <div class="actions-container actions-container--event-over">
                <h2>{{ 'booking-close'|t }}</h2>

                <p>{{ 'booking-close-text'|t }}</p>
            </div>
        </template>

        <!-- Modal notification ok  -->
        <b-modal id="notify" ref="notifyok" size="sm" centered hide-footer hide-header>
            <div class="modal-user-notifyed">
                <h3 class="left-bullet">{{ 'notify-confirmed'|t }}</h3>
                <p>{{ 'stay-tuned'|t }}</p>
                <a href="#" class="btn-link btn-link--small" @click.prevent="closeModal('notifyok')">
                    {{ 'close'|t }}
                </a>
            </div>
        </b-modal>

        <!-- Modal waiting list ok  -->
        <b-modal id="waitinglist" ref="waitinglistok" size="sm" centered hide-footer hide-header>
            <div class="modal-user-notifyed">
                <h3 class="left-bullet">{{ 'asked-for-place-text'|t }}</h3>
                <p>{{ 'asked-place-modal-text'|t }}</p>
                <a href="#" class="btn-link btn-link--small" @click.prevent="closeModal('waitinglistok')">{{ 'close'|t }}</a>
            </div>
        </b-modal>
    </aside>

</template>

<script>
export default {
    props: {
        event: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            tickets: 0,
            status: null,
            userStatus: null
        }
    },
    methods: {
        addTicket() {
            if(this.tickets < this.availableTickets) {
                this.tickets++
            }
        },
        removeTicket() {
            if (this.tickets > 0) {
                this.tickets--
            }
        },
        addToCart() {
            // If user is log in
            if(! this.$auth.check()) {
                this.$router.push('login');
                return;
            }

            // field not empty
            if(! this.tickets) {
                return;
            }

            // Register participation
            Vue.axios.post('/cart', {
                event_id: this.event.id,
                nb_tickets: this.tickets,
            }).then(({data}) => {
                this.$store.setCart(data)
                this.$store.cartDropdown.show()
            }).catch(function (error) {
            })
        },
        toggleNotify() {
            if(! this.$auth.check()) {
                this.$router.push('login');
                return;
            }

            Vue.axios.post(`/events/${this.event.slug}/notify`, {
                event: this.event,
            }).then(({data}) => {

                if(data.status === 'attached') {
                    this.userStatus = 'notification_requested';
                    this.$refs.notifyok.show();
                }

                if(data.status === 'detached') {
                    this.userStatus = null;
                }
            }).catch(function (error) {
            })
        },
        closeModal(modal) {
            this.$refs[modal].hide();
        },
        toggleWaitingList() {
            if(! this.$auth.check()) {
                this.$router.push('login');
                return;
            }

            Vue.axios.post(`/events/${this.event.slug}/waiting-list`, {
                event: this.event,
            }).then(({data}) => {
                if(data.status === 'attached') {
                    if(this.userStatus === 'registered') {
                        this.userStatus = 'registered_and_waiting';
                    } else {
                        this.userStatus = 'on_waiting_list';
                    }
                    this.$refs.waitinglistok.show();
                }

                if(data.status === 'detached') {
                    if(this.userStatus === 'registered_and_waiting') {
                        this.userStatus = 'registered';
                    } else {
                        this.userStatus = null;
                    }
                }
            }).catch(function (error) {
            })
        }
    },
    computed: {
        availableTickets() {
            if (this.event.ticketsAvailable >= this.event.max_tickets_per_user) {
                return this.event.max_tickets_per_user;
            }

            return this.event.ticketsAvailable;
        }
    },
    mounted() {
        this.status = this.event.status;
        this.userStatus = this.event.userStatus;
    }
}
</script>

<i18n>
    {
      "en": {
        "register": "Register",
        "booking-start": "Booking starts",
        "text-notify-guest": "Please log in to get notified once bookings are available.",
        "create-account": "Create an account",
        "login": "Login",
        "text-notify-auth": "Get notified via email once bookings are available.",
        "notify-me": "Notify me",
        "notify-confirmed": "Notification subscription confirmed.",
        "stay-tuned": "You'll get an email once bookings are available. Stay tuned!",
        "close": "Close",
        "reminder-sub": "You subscribed for the reminder",
        "unsub": "Unsubscribe",

        "book": "Book",
        "text-book-guest": "Please log in to add this event to your cart.",

        "add-cart": "Add to cart",
        "tickets-rule": "Admission fees are non-refundable.",
        "tickets-rule-2": "Kulturpass holders and students under 20 with a valid student card can reserve free of charge by sending an email to 1535@differdange.lu (subject to availability).",
        "cgu": "Read our terms of use.",

        "sold-out": "Sold out",
        "sold-out-text-guest": "If you want to be notified if spots become available, please log in or create an account.",
        "sold-out-text": "Get notified via email if spots become available.",
        "asked-for-place-text": "You are on the waiting list.",
        "asked-place-modal-text": "You will receive an email if spots become available. Stay tuned!",

        "booking-close": "Booking closed",
        "booking-close-text": "The event has ended and is no longer available for booking."
      },
      "fr": {
        "register": "S'inscrire",
        "booking-start": "Réservations à partir du",
        "text-notify-guest": "Connectez-vous pour être notifié(e) de l’ouverture des réservations.",
        "create-account": "Créer un compte",
        "login": "Se connecter",
        "text-notify-auth": "Pour être notifié(e) de l’ouverture des réservations par e-mail",
        "notify-me": "Notifiez-moi",
        "notify-confirmed": "Vous êtes inscrit(e) au rappel",
        "stay-tuned": "Vous recevrez un email dès que les réservations seront ouvertes. Tenez-vous prêts !",
        "close": "Fermer",
        "reminder-sub": "Vous êtes inscrit(e) au rappel.",
        "unsub": "Se désinscrire",

        "book": "Réserver",
        "text-book-guest": "Connectez-vous pour ajouter cet événement à votre panier.",

        "add-cart": "Ajouter au panier",
        "tickets-rule": "La réservation aux événements n'est pas remboursable.",
        "tickets-rule-2": "Les détenteur·rice·s du Kulturpass et les étudiant·e·s de moins de 20 ans ayant une carte d'étudiant·e valide peuvent réserver leur participation gratuitement en envoyant un email à 1535@differdange.lu (dans la limite des places disponibles).",
        "cgu": "Lire nos conditions d'utilisation.",

        "sold-out": "Complet",
        "sold-out-text-guest": "Pour être notifié(e) si des places se libèrent, veuillez-vous connecter ou créer un compte.",
        "sold-out-text": "Soyez notifié(e) par e-mail si des places se libèrent.",
        "asked-for-place-text": "Vous êtes inscrit(e) à la liste d’attente",
        "asked-place-modal-text": "Vous recevrez un email dès que des places se libèrent. Tenez-vous prêts !",

        "booking-close": "Réservations terminées",
        "booking-close-text": "L’événement est passé, il n’est plus disponible à la réservation."
      }
    }

</i18n>